import { render, staticRenderFns } from "./subpackageProduct.vue?vue&type=template&id=d4264c2c&scoped=true&"
import script from "./subpackageProduct.vue?vue&type=script&lang=js&"
export * from "./subpackageProduct.vue?vue&type=script&lang=js&"
import style0 from "./subpackageProduct.vue?vue&type=style&index=0&id=d4264c2c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4264c2c",
  null
  
)

export default component.exports